import { render, staticRenderFns } from "./TruckOrders.vue?vue&type=template&id=07abe919&scoped=true&"
import script from "./TruckOrders.vue?vue&type=script&lang=js&"
export * from "./TruckOrders.vue?vue&type=script&lang=js&"
import style0 from "./TruckOrders.vue?vue&type=style&index=0&id=07abe919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07abe919",
  null
  
)

export default component.exports